// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { sparklesNested16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-sparkles-nested': IconSparklesNested;
    }
}

/**
 * The icon component for the 'sparklesNested' icon
 */
export class IconSparklesNested extends IconSvg {
    public constructor() {
        super(sparklesNested16X16);
    }
}

registerIconSvg('icon-sparkles-nested', IconSparklesNested);
export const iconSparklesNestedTag = 'nimble-icon-sparkles-nested';
